import type { CheckoutDictionary } from '@elfsight/widget-checkout';
import { RECAPTCHA_LEGAL_INFO } from '@elfsight/widget-checkout';
import { useLingui } from '@lingui/react/macro';

export function useCheckoutDictionary(): CheckoutDictionary {
  const { t } = useLingui();

  return {
    'Email for payment confirmation': t`Email for payment confirmation`,
    Change: t`Change`,
    'Order Summary': t`Order Summary`,
    Back: t`Back`,
    'Your Details': t`Your Details`,
    'Go To Payment': t`Go To Payment`,
    'Payment is already in process': t`Payment is already in process`,
    'Payment session id is undefined': t`Payment session id is undefined`,
    'Unknown payment session status': t`Unknown payment session status`,
    'Payment failed': t`Payment failed`,
    'Payment session was expired or canceled': t`Payment session was expired or canceled`,
    'Something went wrong': t`Something went wrong`,
    'Pay Now': t`Pay Now`,
    'Processing Payment...': t`Processing Payment...`,
    'Secure payments are processed via': t`Secure payments are processed via`,
    'Unable to load Stripe': t`Unable to load Stripe`,
    'We’re sorry, the payment page isn’t available right now. Please contact us for assistance.': t`We’re sorry, the payment page isn’t available right now. Please contact us for assistance.`,
    'Complete Your Payment': t`Complete Your Payment`,
    'Payment Received': t`Payment Received`,
    [RECAPTCHA_LEGAL_INFO]: t`This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noreferrer noopener">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="nofollow noreferrer noopener">Terms of Service</a> apply.`
  };
}
